import createSpinner from "../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, helperService, roleTemplatesData) {

    const vm = this;
    vm.cancel = cancel;
    vm.dismiss = dismiss;
    vm.disableButton = false;
    vm.importRoleTemplates = importRoleTemplates;

    function cancel() { $uibModalInstance.close(); }
    function dismiss() { $uibModalInstance.dismiss(); }

    // Import Role Templates
    async function importRoleTemplates(file) {
        vm.importPending = new createSpinner();
        vm.disableButton = true;
        let fd = new FormData();
        fd.append(file[0].name, file[0].file);
        try {
            await roleTemplatesData.importRoleTemplates(fd);
            await helperService.successfulSaveButton(vm.importPending);
            cancel();
        } catch {
            vm.importPending.loadingValue = false;
            vm.disableButton = false;
        }
    }
}